import { render, staticRenderFns } from "./CreateCreditCard.vue?vue&type=template&id=2a54bb64&"
import script from "./CreateCreditCard.vue?vue&type=script&lang=js&"
export * from "./CreateCreditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports